import { ChatItem, Env } from "./types";
import { LS_KEYS } from "./constants";

export function loadMessages(): ChatItem[] {
  try {
    const raw = localStorage.getItem(LS_KEYS.messages);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? (parsed as ChatItem[]) : [];
  } catch {
    return [];
  }
}

export function saveMessages(messages: ChatItem[]): void {
  try {
    localStorage.setItem(LS_KEYS.messages, JSON.stringify(messages));
  } catch {}
}

export function loadEnv(): Env | null {
  try {
    const raw = localStorage.getItem(LS_KEYS.env);
    return raw === "dev" || raw === "staging" ? raw : null;
  } catch {
    return null;
  }
}

export function saveEnv(env: Env): void {
  try {
    localStorage.setItem(LS_KEYS.env, env);
  } catch {}
}

export function loadThreadId(): string {
  let id = localStorage.getItem(LS_KEYS.threadId);

  if (!id) {
    try {
      if (
        typeof crypto !== "undefined" &&
        typeof crypto.randomUUID === "function"
      ) {
        id = crypto.randomUUID();
      } else if (
        typeof crypto !== "undefined" &&
        typeof crypto.getRandomValues === "function"
      ) {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);

        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;

        const hex = Array.prototype.map.call(bytes, (b: number) =>
          b.toString(16).padStart(2, "0"),
        ) as string[];

        id = [
          hex.slice(0, 4).join(""),
          hex.slice(4, 6).join(""),
          hex.slice(6, 8).join(""),
          hex.slice(8, 10).join(""),
          hex.slice(10, 16).join(""),
        ].join("-");
      } else {
        console.warn("CSPRNG unavailable — using deterministic timestamp ID.");
        id = `ts-${Date.now().toString(36)}`;
      }

      if (typeof id !== "string" || id.trim() === "") {
        id = `fallback-ts-${Date.now().toString(36)}`;
      }

      localStorage.setItem(LS_KEYS.threadId, id);
    } catch (err) {
      console.error("Failed to generate or persist thread ID:", err);
      id = `recover-ts-${Date.now().toString(36)}`;
    }
  }

  if (typeof id !== "string" || id.trim() === "") {
    id = `final-ts-${Date.now().toString(36)}`;
  }

  return id;
}

export function clearThreadId(): void {
  try {
    localStorage.removeItem(LS_KEYS.threadId);
  } catch {}
}
